import __request__ from "routing/request";
export function bulkImportFromRepo(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp.sigma/sigma/import/bulk/import", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkUpload(files, request, requestOptions) {
  const formData = new FormData();
  files.forEach((f) => formData.append("files", f));
  formData.append("request", request);
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp.sigma/sigma/import/bulk/upload", formData, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validateYaml(files, requestOptions) {
  const formData = new FormData();
  files.forEach((f) => formData.append("files", f));
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp.sigma/sigma/import/validate", formData, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validateZip(file, requestOptions) {
  const formData = new FormData();
  formData.append("file", file);
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp.sigma/sigma/import/validate_zip", formData, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
